import CRUDHelper from '../../services/CRUDHelper';

class UserEmailStore extends CRUDHelper {
  async verifyUserEmail (userId, userEmailId) {
    let response = await fetch(
      `/api/v4/users/${userId}/user_emails/${userEmailId}/verify`, {
        method: 'PATCH'
      });

    return response.json();
  }
};

export default new UserEmailStore('user_email');
